import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-method-item__header-block-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "payment-method-item__header-block-container" }
const _hoisted_4 = { class: "payment-method-item__payment-method-item-form-inputs" }
const _hoisted_5 = {
  key: 0,
  class: "payment-method-item__payment-method-item-form-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "payment-method-item" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "payment-method-item__header" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.modelValue.filePath,
              class: "payment-method-item__header-logo"
            }, null, 8 /* PROPS */, _hoisted_2),
            _createTextVNode(" " + _toDisplayString(_ctx.modelValue.name), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.currentMethodState.active,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMethodState.active) = $event)),
              disabled: _ctx.isEditing,
              size: "small",
              onChange: _ctx.setActiveStatus
            }, null, 8 /* PROPS */, ["modelValue", "disabled", "onChange"]),
            _createVNode(_component_el_button, {
              disabled: _ctx.isEditing,
              icon: _ctx.icons.Edit,
              circle: "",
              size: "small",
              class: "payment-method-item__header-action-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEditing(true)))
            }, null, 8 /* PROPS */, ["disabled", "icon"]),
            _createVNode(_component_el_button, {
              disabled: _ctx.isEditing,
              icon: _ctx.icons.Delete,
              circle: "",
              size: "small",
              class: "payment-method-item__header-action-button",
              onClick: _ctx.deletePaymentMethod
            }, null, 8 /* PROPS */, ["disabled", "icon", "onClick"])
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            "label-position": "top",
            model: _ctx.currentMethodState,
            rules: _ctx.associatedMethodSettingsFormRules,
            class: "payment-method-item__payment-method-item-form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  label: "Withdrawal min",
                  prop: "withdrawalRangeMin"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.currentMethodState.withdrawalRangeMin,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentMethodState.withdrawalRangeMin) = $event)),
                      disabled: !_ctx.isEditing,
                      controls: false
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  label: "Withdrawal max",
                  prop: "withdrawalRangeMax"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.currentMethodState.withdrawalRangeMax,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentMethodState.withdrawalRangeMax) = $event)),
                      disabled: !_ctx.isEditing,
                      controls: false
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              (_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_button, { onClick: _ctx.resetCurrentMethodState }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancel ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.updatePaymentMethod
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Apply ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}